import UserLayout from "../components/UserLayout";
import CustomerChildUsersPanel from "../components/users/CustomerChildUsersPanel";

const ChildUsersPage = () => (
  <UserLayout>
    <CustomerChildUsersPanel />
  </UserLayout>
);

export default ChildUsersPage;
